import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Layout } from '@/components/layout'
import { ArrowLeft } from 'lucide-react'

export function NotFoundPage() {
  const { t } = useTranslation()

  const handleGoBack = () => {
    window.history.back()
  }

  return (
    <Layout showNavigation={false} showCrisisTopbar={false}>
      <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <Card variant="elevated" className="animate-fade-in glass-card dark:glass-card">
            <CardHeader className="text-center space-y-3">
              <CardTitle className="text-2xl">404</CardTitle>
              <CardDescription className="text-base">
                {t('error.pageNotFound', 'This page does not exist')}
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="text-center">
                <p className="text-muted-foreground mb-6">
                  {t(
                    'error.pageNotFoundDescription',
                    'The page you are looking for could not be found.'
                  )}
                </p>
                <Button
                  onClick={handleGoBack}
                  className="w-full h-12 text-base font-semibold justify-center"
                  variant="gradient"
                >
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  {t('navigatie.back', 'Go back')}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  )
}
